import React from "react";

const PostLoginCategories = ({ popularCategories, onSubmitCategory }) => (
  <div className="col-sm-6">
    {(popularCategories.length && (
      <div className="most-popular">
        <h5>Most Popular Categories</h5>

        <div className="white-bg">
          <ul>
            {popularCategories.map(category => (
              <li
                key={category.id}
                className="cursor-pointer"
                onClick={() =>
                  onSubmitCategory(
                    category.name,
                    category.resultType,
                    category.restaurantAddressPostalCode,
                    category.restaurantAddressSlugAdminWard,
                    category.restaurantAddressSlugCityName,
                    category.restaurantSlugName
                  )
                }
              >
                <a href="javascript: void(0)">{category.name}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )) || <noscript />}
  </div>
);

export default PostLoginCategories;
